export default __webpack_public_path__ + "static/media/header-logo.c8026d92.png";